"use strict";

var _interopRequireDefault = require("/app/node_modules/@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./styles/quasar.scss");

var _es = _interopRequireDefault(require("quasar/lang/es.js"));

require("@quasar/extras/roboto-font/roboto-font.css");

require("@quasar/extras/material-icons/material-icons.css");

var _quasar2 = require("quasar");

// To be used on app.use(Quasar, { ... })
var _default = {
  config: {},
  plugins: {
    Notify: _quasar2.Notify
  },
  lang: _es.default,
  supportTS: true
};
exports.default = _default;